import React, {useEffect, useMemo} from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {useCheckerHeaderUIContext} from './CollectHeaderUIContext';
import * as actions from '../../../MasterData/_redux/user/userAction';
import {ActionsColumnFormatter} from './ActionsColumnsFormatter';

export function CollectTable() {

    // DonationHeader UI Context
    const checkerHeaderUIContext = useCheckerHeaderUIContext();
    const checkerHeaderUIProps = useMemo(() => {
        return {
            queryParams: checkerHeaderUIContext.queryParams,
            setQueryParams: checkerHeaderUIContext.setQueryParams,
            selectedChecker: checkerHeaderUIContext.selectedChecker,
        };
    }, [checkerHeaderUIContext]);

    // Getting curret state of user checker list from store (Redux)
    const {currentState} = useSelector(
        (state) => ({currentState: state.users}),
        shallowEqual,
    );

    const {entities} = currentState;

    const dispatch = useDispatch();
    useEffect(() => {
        //Requset ke Donatur Action
        checkerHeaderUIProps.queryParams.filter.role = ['Checker', 'FundCollCheck', 'KepalaCabang']; // Add role in query params
        dispatch(actions.fetchUsers(checkerHeaderUIProps.queryParams));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkerHeaderUIProps.queryParams, dispatch]);

    const columns = [
        {
            dataField: 'name',
            text: 'Name',
        },
        {
            dataField: 'email',
            text: 'Email',
        },
        {
            dataField: 'action',
            text: 'Actions',
            formatter: ActionsColumnFormatter,
            formatExtraData: {
                selectedChecker: checkerHeaderUIProps.selectedChecker,
            },
            classes: 'text-right pr-0',
            headerClasses: 'text-right pr-3',
            style: {
                minWidth: '100px',
            },
        },
    ];
    return (
        <>
            <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="uuid"
                data={entities === null ? [] : entities}
                columns={columns}
            >
            </BootstrapTable>
        </>
    );
}

